import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['template', 'dialog', 'title', 'content']
  static classes = ['title', 'content']

  append({ currentTarget }) {
    this.element.appendChild(this.#template)

    const item = currentTarget.parentNode
    this.titleTarget.textContent = item.querySelector(`.${ this.titleClass }`).textContent
    this.contentTarget.innerHTML = item.querySelector(`.${ this.contentClass }`).innerHTML

    this.dispatch('append')
  }

  removeOnClose({ newState }) {
    if (newState === 'closed') {
      this.dialogTarget.remove()
    }
  }

  get #template() {
    return this.templateTarget.content.cloneNode(true)
  }
}
